<div class="button-input-style-provider"><div class="button-input-style-provider-wrapper" :class="type"><slot></slot></div></div>